module.exports = __webpack_public_path__ + "static/media/coffee-break.d4c48fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/biznisnet2020/resources/coffee-break.jpg
// module id = 454
// module chunks = 0